
define('eteration/widgets/ui-timerangegrid',[ 'knockout', 'eteration/widgets/widget-util', 'moment' ], function(ko, widgetUtil, moment) {
	widgetUtil.setupStringBasedTemplate(ko);
	ko.templates["time-range-grid"] ='<!-- ko foreach: ko.utils.range(1, sliceCount)-->\
										  <div  class="rangeslidergrid" data-bind="css:{\'passivedepart\': $index() < $parent.start || $index()>=$parent.end},style:{width:$parent.width}"></div>\
									 <!-- /ko  -->';
	ko.bindingHandlers['time-range-grid'] = {
			
		makeTemplateValueAccessor : function(valueAccessor, allBindings, element) {
		
			var timeframe =  ko.unwrap(valueAccessor().timeframe);
			var sliceCount = 0;

			if ( timeframe ) {
				sliceCount = timeframe.sliderValues.length - 1;
			}			
			
			
			var start = ko.unwrap(valueAccessor().start);
			var end = ko.unwrap(valueAccessor().end);
			
			
			

			
			return function() {
				return {
					name : 'time-range-grid',
					data : {
						'sliceCount':sliceCount,
						'start':start,
						'end':end,
						'width':(100/sliceCount).toFixed(3)+'%'
					}
				};
			};
		},
		
		init : function(element, valueAccessor, allBindings) {
			$(element).addClass("rangesliderwrapper");
			return ko.bindingHandlers.template.init(element, ko.bindingHandlers['time-range-grid'].makeTemplateValueAccessor(valueAccessor, allBindings, element), allBindings);
		},
		
		update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			return ko.bindingHandlers.template.update(element, ko.bindingHandlers['time-range-grid'].makeTemplateValueAccessor(valueAccessor, allBindings, element), allBindings, viewModel, bindingContext);
		}
		
	};
	
	ko.virtualElements.allowedBindings['time-range-grid'] = true;
	
});
